import { useBoolean } from '@aibees/shared/hooks';
import { createContext, useContext } from 'react';
import {
  EditRoleDialogContextData as ContextData,
  EditRoleDialogContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useEditRoleDialogContext = () => useContext(context);

export const EditRoleDialogProvider = ({ children }: ContextProps) => {
  const submitButtonDisabled = useBoolean(false);
  return <Provider value={{ submitButtonDisabled }}> {children}</Provider>;
};
